/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.action.recommendation.rpc.AutomationActionRecommendationRpc
 */

export const getRecommendationsRpc = {
  serviceName: 'com.hubspot.automation.action.recommendation.rpc.AutomationActionRecommendationRpc',
  rpcName: 'getRecommendations',
  auth: 'app',
  fingerprint: 'Easq2KW-2frMkNpTB1z-n_n-j1XGltm_'
};
export const submitFeedbackRpc = {
  serviceName: 'com.hubspot.automation.action.recommendation.rpc.AutomationActionRecommendationRpc',
  rpcName: 'submitFeedback',
  auth: 'app',
  fingerprint: 'sTP-SPqR1LsIUvdEhH7zwWphXtsTmDDq'
};